namespace GeniuzPOS.Purchase {
    export class ReportPendingPRDtColumns {
        static columnsKey = 'Purchase.ReportPendingPRDt';
    }
}
